import axios, { AxiosRequestConfig } from "axios"
import cfg from "../core/utils/config"

const createClient = (config: AxiosRequestConfig) => axios.create(config)

export const getApiClient = () => {
  const config = {
    baseURL: cfg.api.baseUrl,
    headers: {
      "Ocp-Apim-Subscription-Key": cfg.api.subscriptionKey,
      "Content-Type": "application/json",
      "X-MBA-Application-ID": 'jiltons',
      "X-MBA-Application-Type": 'mypetparlorapp',
      "X-MBA-Deployment-Location": 'za1',
    },
  }

  return createClient(config)
}
